import Papa from 'papaparse';

type PapaParseConfig = {
  delimiter: string;
  header?: boolean;
  preview?: number;
};

type PapaParseResult<TRow> = {
  data: TRow[];
  /** Without `header`, only quoting problems; `row` counts the header as 0. */
  errors: { code: string; row: number }[];
  meta: { delimiter: string; fields?: string[] };
};

/** The slice of papaparse the CSV import relies on; the package ships no types. */
type TypedPapa = {
  parse: <TRow>(text: string, config: PapaParseConfig) => PapaParseResult<TRow>;
  unparse: (
    input: { fields: readonly string[]; data: string[][] },
    config: { delimiter: string },
  ) => string;
};

export const papa = Papa as TypedPapa;
